import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-tab', {
    staticClass: "mt-5",
    attrs: {
      "title": "Problema",
      "active": _vm.isTheCurrentTab,
      "disabled": !_vm.isTheCurrentTab && !_vm.store.isUpdate
    },
    on: {
      "click": function click() {
        return _vm.store.currentTab = 2;
      }
    }
  }, [_c('b-row', {
    staticClass: "p-4"
  }, [_c('b-col', {
    staticClass: "w-100"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Problema",
      "label-for": "problema"
    }
  }, [_c(VTextarea, {
    attrs: {
      "full-width": "",
      "rows": "6"
    },
    model: {
      value: _vm.form.problema,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "problema", $$v);
      },
      expression: "form.problema"
    }
  })], 1)], 1)], 1), _vm.store.trabalharHorasOs ? _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Período do serviço?",
      "label-for": "periodo"
    }
  }, [_c('b-form-select', {
    model: {
      value: _vm.periodo,
      callback: function callback($$v) {
        _vm.periodo = $$v;
      },
      expression: "periodo"
    }
  }, _vm._l(_vm.periodos, function (p, index) {
    return _c('b-form-select-option', {
      key: 'tipo_periodo' + index,
      attrs: {
        "value": p.descricao
      }
    }, [_vm._v(" " + _vm._s(p.descricao) + " ")]);
  }), 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "dataServico",
      "label-for": "dataServico",
      "label": "Data"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.dataServico,
      callback: function callback($$v) {
        _vm.dataServico = $$v;
      },
      expression: "dataServico"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "horaInicio",
      "label-for": "horaInicio",
      "label": "Hora de Início"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "time"
    },
    model: {
      value: _vm.horaInicio,
      callback: function callback($$v) {
        _vm.horaInicio = $$v;
      },
      expression: "horaInicio"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "horaFinal",
      "label-for": "horaFinal",
      "label": "Hora Final"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "time"
    },
    model: {
      value: _vm.horaFinal,
      callback: function callback($$v) {
        _vm.horaFinal = $$v;
      },
      expression: "horaFinal"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "valorServico",
      "label-for": "valorServico",
      "label": "R$ Valor do horário"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "unitario",
      "name": "unitario"
    },
    model: {
      value: _vm.valorServico,
      callback: function callback($$v) {
        _vm.valorServico = $$v;
      },
      expression: "valorServico"
    }
  }, 'money', _vm.priceOptions, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "1"
    }
  }, [_c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.bottom",
      value: 'Adicionar Horário',
      expression: "'Adicionar Horário'",
      modifiers: {
        "bottom": true
      }
    }],
    on: {
      "click": function click($event) {
        return _vm.addServico();
      }
    }
  }, [_c('Plus', {
    staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2"
  })], 1)]), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-table-responsive', [_c('table', {
    staticClass: "table w-100",
    attrs: {
      "id": "table-horarios"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Data")]), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Período")]), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Hora Início")]), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Hora Final")]), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("R$ Valor")]), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Ações")])])]), _vm._l(_vm.horarios, function (item, index) {
    return _c('tbody', {
      key: index
    }, [_c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: index != 'totalHoras',
        expression: "index != 'totalHoras'"
      }]
    }, [_c('th', [_vm._v(_vm._s(_vm.formatDate(item.dataServico)))]), _c('th', [_vm._v(_vm._s(item.periodo))]), _c('td', [_vm._v(_vm._s(item.horaInicio))]), _c('td', [_vm._v(_vm._s(item.horaFinal))]), _c('td', [_vm._v(_vm._s(_vm.numberToReal(item.valorServico, 2)))]), _c('td', [_c('button', {
      staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
      attrs: {
        "title": "Excluir"
      },
      on: {
        "click": function click($event) {
          return _vm.excluir(index);
        }
      }
    }, [_c('i', {
      staticClass: "la la-trash"
    })])])])]);
  }), _c('tfoot', [_c('tr', [_c('td', [_c('strong', [_vm._v("Total de Horas:")])]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.totalHoras))])])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Total R$:")])]), _c('td', [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "total",
      "name": "total"
    },
    model: {
      value: _vm.totalReaisHorarioEditavel,
      callback: function callback($$v) {
        _vm.totalReaisHorarioEditavel = $$v;
      },
      expression: "totalReaisHorarioEditavel"
    }
  }, 'money', _vm.priceOptions, false))], 1)])])], 2)])], 1)], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };